import React, { useState, useEffect } from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';

import ProjectSettingCoverTitleStep from 'components/containers/group/project/ProjectSettingCoverTitleStep';
import ProjectSettingDescriptionStep from 'components/containers/group/project/ProjectSettingDescriptionStep';
import ProjectSettingPeriodStep from 'components/containers/group/project/ProjectSettingPeriodStep';
import ProjectSettingTodoListStep from 'components/containers/group/project/ProjectSettingTodoListStep';
import ProjectSettingSampleProofStep from 'components/containers/group/project/ProjectSettingSampleProofStep';

import serverController from 'server/serverController';
import server from 'server/serverController2';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Fitgroupinner,
  Modal,
  ModalTitle,
  ModalContentInner,
  ModalBg,
  ModalButtonInner,
  ModalCancelBtn,
  ModalBtn,
} from './style';

export default function CreateGroupProjectLayout({ match }) {
  const history = useHistory();

  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  const [showModal, setShowModal] = useState(false);
  const [fitIntroductContent, setFitIntroductContent] = useState('');
  const [screenIndex, setScreenIndex] = useState(0);

  const [projectImg, setProjectImg] = useState(null);
  const [projectTitle, setProjectTitle] = useState('');
  const [projectInfo, setProjectInfo] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [periodCheck, setPeriodCheck] = useState('');

  const [dayOfWeek, setDayOfWeek] = useState([]);
  const [images, setImages] = useState(null);
  const [inputlist, setInputlist] = useState([
    {
      title: null,
      start_date: null,
      end_date: null,
      day: null,
      time: null,
      alarm_time: null,
    },
  ]);
  let imagePathArray = [];

  useEffect(() => {
    if (userInfo['isLogin'] === false) {
      alert('로그인이 필요합니다.');
      history.replace('/social');
    }
  }, []);

  const callBack = (res) => {
    isclick = false;
    if (res.success === 1) {
      let targetProjectNo = res.data.inserted_item.no;
      let targetGroupNo = res.data.inserted_item.group_no;
      let redirectUrl = `/group/${targetGroupNo}/project/${targetProjectNo}`;
      history.replace(redirectUrl);
    } else {
      if (res['error'] && res['error']['res_data']) {
        let errData = res['error']['res_data'];
        if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.replace('/social');
        } else if (errData['detail_code'] === 'NOT_AN_ADMIN') {
          alert('모임 관리자가 아닙니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'NOT_A_GROUP_MEMBER') {
          alert('해당 모임 참여자가 아닙니다.');
          history.goBack();
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
    }
  };
  const groupCoverImgUploadCallBack = async (data) => {
    if (data.success === 1) {
      var coverImage = [];
      data.data.upload_results.map((value) => {
        coverImage.push(value.file_name);
      });

      var list = inputlist.map((value) => {
        value.start_date = startDate;
        value.end_date = endDate;
        value.day = dayOfWeek;
        return value;
      });

      let serverData = {
        title: projectTitle,
        description: projectInfo,
        start_date: startDate,
        end_date: endDate,
        day: dayOfWeek,
        cover_img: coverImage.pop(),
        tasks: list,
      };

      if (imagePathArray) serverData.sample_proof = imagePathArray;
      serverController.generalPostFetchController(
        `groups/${match.params.group_no}/projects`,
        JSON.stringify(serverData),
        callBack,
      );
    } else {
      if (data['error'] && data['error']['res_data']) {
        let errData = data['error']['res_data'];
        if (errData['detail_code'] === 'LOGIN_REQ') {
          alert('로그인이 필요합니다.');
          history.replace('/social');
        } else if (errData['detail_code'] === 'INVALID_FILE_PATH') {
          alert('파일 업로드 경로가 지정되지 않았습니다.');
          history.goBack();
        } else if (errData['detail_code'] === 'FILE_NOT_PROVIDED') {
          alert('업로드 파일이 지정되지 않았습니다.');
          history.goBack();
        } else {
          alert('예기치 못한 오류가 발생하였습니다.');
          history.push('/');
        }
      }
    }
  };

  /*--click block--*/
  var isclick = false;
  const createProject = async () => {
    let formData = new FormData();
    formData.append('file', projectImg);
    formData.append('path', 'group_project_cover_img/');

    serverController.updatefilePostFetchController(
      `file`,
      formData,
      groupCoverImgUploadCallBack,
    );
  };

  /*--click block--*/
  const dataSubmit = async () => {
    if (isclick) return;
    isclick = true;

    if (!projectImg) {
      alert('대표이미지를 설정해주셔야합니다.');
      return;
    }

    if (images && Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let formData = new FormData();
        formData.append('file', images[i]);
        formData.append('path', 'group_project_sample_proof_img/');
        let resposne = await server.postRequestFormData(
          `file`,
          formData );

        if (resposne.success === 1) {
          resposne.data.upload_results.map((value) => {
            imagePathArray.push(value.file_name);
          });
        } else {
          if (resposne['error'] && resposne['error']['res_data']) {
            let errData = resposne['error']['res_data'];
            if (errData['detail_code'] === 'LOGIN_REQ') {
              alert('로그인이 필요합니다.');
              history.replace('/social');
            } else if (errData['detail_code'] === 'INVALID_FILE_PATH') {
              alert('파일 업로드 경로가 지정되지 않았습니다.');
              history.goBack();
            } else if (errData['detail_code'] === 'FILE_NOT_PROVIDED') {
              alert('업로드 파일이 지정되지 않았습니다.');
              history.goBack();
            } else {
              alert('예기치 못한 오류가 발생하였습니다.');
              history.push('/');
            }
          }
        }
      }
      createProject(); 
    } else{createProject(); }
  };

  const updateNext = (index) => {
    if (screenIndex + index === -1 || screenIndex + index > 4) return;

    setScreenIndex(screenIndex + index);
  };

  let renderPageController = () => {
    switch (screenIndex) {
      case 0:
        return (
          <ProjectSettingCoverTitleStep
            fitIntroductContent={fitIntroductContent}
            updateNext={updateNext}
            setFitIntroductContent={setFitIntroductContent}
            titname={'프로젝트 이름'}
            subtit={'모임 내에서 세부적인 프로젝트들을 진행 할 수 있어요!'}
            marginTop={'calc(100vw*(-10/375));'}
            paddingBottom={'calc(100vw*(15/375))'}
            placeholder={'ex) 매일 10분 하체 스트레칭'}
            projectImg={projectImg}
            setProjectImg={setProjectImg}
            projectTitle={projectTitle}
            setProjectTitle={setProjectTitle}
          />
        );
      case 1:
        return (
          <ProjectSettingDescriptionStep
            updateNext={updateNext}
            title={'프로젝트 소개'}
            infotext={
              '본인 프로젝트에 대한 간단한 소개 및 주의사항 / 가이드라인을 제시해 주세요'
            }
            placeholder={
              'ex) 이 프로젝트는 매일 간단하게 스트레칭을 하는 프로젝트입니다. 매일 10분씩 인증해 주시면 됩니다.'
            }
            projectInfo={projectInfo}
            setProjectInfo={setProjectInfo}
          />
        );
      case 2:
        return (
          <ProjectSettingPeriodStep
            updateNext={updateNext}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            periodCheck={periodCheck}
            setPeriodCheck={setPeriodCheck}
            dayOfWeek={dayOfWeek}
            setDayOfWeek={setDayOfWeek}
          />
        );
      case 3:
        return (
          <ProjectSettingTodoListStep
            updateNext={updateNext}
            inputlist={inputlist}
            setInputlist={setInputlist}
          />
        );
      case 4:
        return (
          <ProjectSettingSampleProofStep
            updateNext={updateNext}
            dataSubmit={dataSubmit}
            images={images}
            setImages={setImages}
          />
        );
    }
  };

  return (
    <Fitgroupinner>
      <TitleHeader
        isCloseBtn={true}
        setShowModal={setShowModal}
        title={'프로젝트 만들기'}
        borderbottom={'solid 1px #d5d5d5'}
      />
      {renderPageController()}

      {showModal ? (
        <div>
          <ModalBg></ModalBg>
          <Modal>
            <ModalTitle>프로젝트 만들기 취소</ModalTitle>
            <ModalContentInner>
              프로젝트 만들기를 취소하시겠어요?
            </ModalContentInner>
            <ModalButtonInner>
              <ModalCancelBtn
                onClick={() => {
                  setShowModal(false);
                }}
                style={{ borderRight: 'calc(100vw*(1/375)) solid #c6c6c6' }}
              >
                {'취소'}
              </ModalCancelBtn>
              <ModalBtn to={`/GroupDetail/${match.params.group_no}`}>
                {'확인'}
              </ModalBtn>
            </ModalButtonInner>
          </Modal>
        </div>
      ) : null}
    </Fitgroupinner>
  );
}
